/* eslint-disable import/newline-after-import */
/* Exports all the actions from a single point.

Allows to import actions like so:

import {action1, action2} from '../actions/'
*/
/* Populated by react-webpack-redux:action */
import customerJourneyMailUnsubscribeError from '../actions/customerJourney/customerJourneyMailUnsubscribeError.js';
import customerJourneyMailUnsubscribeSuccess from '../actions/customerJourney/customerJourneyMailUnsubscribeSuccess.js';
import customerJourneyMailUnsubscribe from '../actions/customerJourney/customerJourneyMailUnsubscribe.js';
import customerJourneyWeatherSuccess from '../actions/customerJourney/customerJourneyWeatherSuccess.js';
import customerJourneyWeatherError from '../actions/customerJourney/customerJourneyWeatherError.js';
import customerJourneyWeather from '../actions/customerJourney/customerJourneyWeather.js';
import customerJourneyLoginError from '../actions/customerJourney/customerJourneyLoginError.js';
import customerJourneyLoginSuccess from '../actions/customerJourney/customerJourneyLoginSuccess.js';
import customerJourneyLogin from '../actions/customerJourney/customerJourneyLogin.js';
import customerJourneyLoginReservationError from '../actions/customerJourney/customerJourneyLoginReservationError.js';
import customerJourneyLoginReservationSuccess from '../actions/customerJourney/customerJourneyLoginReservationSuccess.js';
import customerJourneyLoginReservation from '../actions/customerJourney/customerJourneyLoginReservation.js';
import setLang from '../actions/commons/setLang.js';
import customerJourneyServicesBookError from '../actions/customerJourney/customerJourneyServicesBookError.js';
import customerJourneyServicesBookSuccess from '../actions/customerJourney/customerJourneyServicesBookSuccess.js';
import customerJourneyServicesBook from '../actions/customerJourney/customerJourneyServicesBook.js';
import customerJourneyServicesError from '../actions/customerJourney/customerJourneyServicesError.js';
import customerJourneyServicesSuccess from '../actions/customerJourney/customerJourneyServicesSuccess.js';
import customerJourneyServices from '../actions/customerJourney/customerJourneyServices.js';
import customerJourneyVenuesError from '../actions/customerJourney/customerJourneyVenuesError.js';
import customerJourneyVenuesSuccess from '../actions/customerJourney/customerJourneyVenuesSuccess.js';
import customerJourneyVenues from '../actions/customerJourney/customerJourneyVenues.js';
import customerJourneyMenuError from '../actions/customerJourney/customerJourneyMenuError.js';
import customerJourneyMenuSuccess from '../actions/customerJourney/customerJourneyMenuSuccess.js';
import customerJourneyMenu from '../actions/customerJourney/customerJourneyMenu.js';
import customerJourneyAttractionsError from '../actions/customerJourney/customerJourneyAttractionsError.js';
import customerJourneyAttractionsSuccess from '../actions/customerJourney/customerJourneyAttractionsSuccess.js';
import customerJourneyAttractions from '../actions/customerJourney/customerJourneyAttractions.js';
import customerJourneyEventsCategoryError from '../actions/customerJourney/customerJourneyEventsCategoryError.js';
import customerJourneyEventsCategorySuccess from '../actions/customerJourney/customerJourneyEventsCategorySuccess.js';
import customerJourneyEventsCategory from '../actions/customerJourney/customerJourneyEventsCategory.js';
import customerJourneyEventsCategoriesError from '../actions/customerJourney/customerJourneyEventsCategoriesError.js';
import customerJourneyEventsCategoriesSuccess from '../actions/customerJourney/customerJourneyEventsCategoriesSuccess.js';
import customerJourneyEventsCategories from '../actions/customerJourney/customerJourneyEventsCategories.js';
import customerJourneyCategoriesError from '../actions/customerJourney/customerJourneyCategoriesError.js';
import customerJourneyCategoriesSuccess from '../actions/customerJourney/customerJourneyCategoriesSuccess.js';
import customerJourneyCategories from '../actions/customerJourney/customerJourneyCategories.js';
import customerJourneyReservationError from '../actions/customerJourney/customerJourneyReservationError.js';
import customerJourneyReservationSuccess from '../actions/customerJourney/customerJourneyReservationSuccess.js';
import customerJourneyReservation from '../actions/customerJourney/customerJourneyReservation.js';
import customerJourneyHotelError from '../actions/customerJourney/customerJourneyHotelError.js';
import customerJourneyHotelSuccess from '../actions/customerJourney/customerJourneyHotelSuccess.js';
import customerJourneyHotel from '../actions/customerJourney/customerJourneyHotel.js';
import set_token from '../actions/commons/set_token.js';
import duringStaySurveySendAnswer from '../actions/customerJourney/duringStaySurveySendAnswer';
import duringStaySurveySendAnswerSuccess from '../actions/customerJourney/duringStaySurveySendAnswerSuccess';
import duringStaySurveySendAnswerError from '../actions/customerJourney/duringStaySurveySendAnswerError';
import duringStaySurveyGetAnswer from '../actions/customerJourney/duringStaySurveyGetAnswer';
import duringStaySurveyGetAnswerSuccess from '../actions/customerJourney/duringStaySurveyGetAnswerSuccess';
import duringStaySurveyGetAnswerError from '../actions/customerJourney/duringStaySurveyGetAnswerError';
import customerJourneyNewsCategoryError from '../actions/customerJourney/customerJourneyNewsCategoryError.js';
import customerJourneyNewsCategorySuccess from '../actions/customerJourney/customerJourneyNewsCategorySuccess.js';
import customerJourneyNewsCategory from '../actions/customerJourney/customerJourneyNewsCategory.js';
import customerJourneyNewsCategoriesError from '../actions/customerJourney/customerJourneyNewsCategoriesError.js';
import customerJourneyNewsCategoriesSuccess from '../actions/customerJourney/customerJourneyNewsCategoriesSuccess.js';
import customerJourneyNewsCategories from '../actions/customerJourney/customerJourneyNewsCategories.js';
const actions = {
  set_token,
  customerJourneyHotel,
  customerJourneyHotelSuccess,
  customerJourneyHotelError,
  customerJourneyReservation,
  customerJourneyReservationSuccess,
  customerJourneyReservationError,
  customerJourneyCategories,
  customerJourneyCategoriesSuccess,
  customerJourneyCategoriesError,
  customerJourneyEventsCategories,
  customerJourneyEventsCategoriesSuccess,
  customerJourneyEventsCategoriesError,
  customerJourneyEventsCategory,
  customerJourneyEventsCategorySuccess,
  customerJourneyEventsCategoryError,
  customerJourneyAttractions,
  customerJourneyAttractionsSuccess,
  customerJourneyAttractionsError,
  customerJourneyMenu,
  customerJourneyMenuSuccess,
  customerJourneyMenuError,
  customerJourneyVenues,
  customerJourneyVenuesSuccess,
  customerJourneyVenuesError,
  customerJourneyServices,
  customerJourneyServicesSuccess,
  customerJourneyServicesError,
  customerJourneyServicesBook,
  customerJourneyServicesBookSuccess,
  customerJourneyServicesBookError,
  setLang,
  customerJourneyLogin,
  customerJourneyLoginSuccess,
  customerJourneyLoginError,
  customerJourneyLoginReservation,
  customerJourneyLoginReservationSuccess,
  customerJourneyLoginReservationError,
  customerJourneyWeather,
  customerJourneyWeatherError,
  customerJourneyWeatherSuccess,
  customerJourneyMailUnsubscribe,
  customerJourneyMailUnsubscribeSuccess,
  customerJourneyMailUnsubscribeError,
  customerJourneyNewsCategories,
  customerJourneyNewsCategoriesSuccess,
  customerJourneyNewsCategoriesError,
  customerJourneyNewsCategory,
  customerJourneyNewsCategorySuccess,
  customerJourneyNewsCategoryError,
  duringStaySurveySendAnswer,
  duringStaySurveySendAnswerSuccess,
  duringStaySurveySendAnswerError,
  duringStaySurveyGetAnswer,
  duringStaySurveyGetAnswerSuccess,
  duringStaySurveyGetAnswerError,
};
module.exports = actions;



// WEBPACK FOOTER //
// ./actions/index.js